var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39894 8.54897C8.74615 8.54897 10.6489 6.64618 10.6489 4.29896C10.6489 1.95174 8.74615 0.0489502 6.39894 0.0489502C4.05172 0.0489502 2.14893 1.95174 2.14893 4.29896C2.14893 6.64618 4.05172 8.54897 6.39894 8.54897Z",
    fill: "#27548C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39894 9.96558C2.87973 9.96949 0.0278438 12.8214 0.0239258 16.3406C0.0239258 16.7318 0.34105 17.0489 0.73225 17.0489H12.0656C12.4568 17.0489 12.7739 16.7318 12.7739 16.3406C12.77 12.8214 9.91815 9.96946 6.39894 9.96558Z",
    fill: "#27548C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.7227e47fa478b8a1d0e84dc7070d279f.svg";
export { ForwardRef as ReactComponent };